import { create } from 'zustand'

/** The second key of `U then <key>`, once pressed on the Device Management page. */
export type DeviceActionSequenceKey = 'f' | 'c' | 'g' | 'm' | 's'

interface DeviceActionSequenceState {
	pendingKey: DeviceActionSequenceKey | null
	request: (key: DeviceActionSequenceKey) => void
	clear: () => void
}

/**
 * Bridges `U then <key>` (armed globally by the sequence engine, which has no view of any page's
 * selection) to the Device Management page (which owns the selection and the toolbar that already runs
 * each action). The page's own runner resolves the target and clears this once handled.
 */
export const useDeviceActionSequenceStore = create<DeviceActionSequenceState>()(set => ({
	pendingKey: null,
	request: key => set({ pendingKey: key }),
	clear: () => set({ pendingKey: null }),
}))
